import axios, { AxiosInstance } from "axios";
import { ResponseCode } from "constants/response";
import { payloadHelper } from "helpers/payload-helper";

const axiosRequest: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_DOMAIN,
  headers: {
    //
  },
});

interface ApiResponse<T> {
  status: number;
  msg: string;
  has_pin?: number;
  data: T;
}

async function fetchAPI<Props>(
  payload: unknown,
  method: string,
  typeName: string | null
) {
  try {
    const res = await axiosRequest.post<ApiResponse<Props>>(
      "/",
      payloadHelper(method, typeName, payload)
    );
    if (res.data.status !== ResponseCode.SUCCESS) {
      return Promise.reject(res.data.msg);
    }
    return res.data;
  } catch (error) {
    return Promise.reject(error);
  }
}
export { fetchAPI };
export default axiosRequest;
